import { Booking, WalletMore } from '@/types/booking'
import { requestWithRetry } from '../axios'
import { cacheWallet, getCachedWallet } from '../cache/walletCache'

// order/tickets is the slim wallet: ticket data only, keyed with `order_uid` /
// `ticket_uid`. Map those back to `uid` so the rest of the app keeps the
// existing Booking/Order/Ticket shape; per-order `state`/`config` is loaded on
// demand from order/<uid>/state (see getOrderState).
const normalizeBooking = (booking: any) => ({
  ...booking,
  orders: (booking.orders ?? []).map((order: any) => ({
    ...order,
    uid: order.order_uid,
    // An order can span instances, so order_uid alone is not a unique key.
    instance_uid: booking.instance_uid,
    tickets: (order.tickets ?? []).map((ticket: any) => ({
      ...ticket,
      uid: ticket.ticket_uid,
    })),
  })),
})

export const getTickets = async (
  signal?: AbortSignal,
): Promise<{ wallet: Booking[]; more?: WalletMore }> => {
  try {
    const result = await requestWithRetry(
      'order/tickets',
      'get',
      undefined,
      undefined,
      signal,
    )
    const wallet = (result.wallet ?? []).map(normalizeBooking) as Booking[]
    cacheWallet(wallet)
    return { wallet, more: result.more ?? undefined }
  } catch (error) {
    const cached = getCachedWallet()
    if (cached) {
      return { wallet: cached }
    }
    throw error
  }
}
